// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.house[data-v-7397b9b7] {
    position: relative;
    margin-top: 0;
    margin-bottom: 0;
    margin-left: auto;
    margin-right: auto;
    width: 50rem;
    --tw-translate-y: -13px;
    --tw-translate-x: -105px;
    --tw-scale-x: .85;
    --tw-scale-y: .85;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@media (min-width: 996px) {
.house[data-v-7397b9b7] {
        height: 672px;
}
}
.house__wrapper[data-v-7397b9b7] {
    width: 34rem;
}
@media (min-width: 996px) {
.house__wrapper[data-v-7397b9b7] {
        height: 672px;
}
}
.house__bg-cloud[data-v-7397b9b7],
  .house__bg-house[data-v-7397b9b7],
  .house__bg-phone[data-v-7397b9b7],
  .house__cloud-1[data-v-7397b9b7],
  .house__cloud-2[data-v-7397b9b7],
  .house__star[data-v-7397b9b7] {
    position: absolute;
}
.house__star[data-v-7397b9b7] {
    top: 100px;
    left: 100px;
    z-index: -1;
}
.house__bg-cloud[data-v-7397b9b7] {
    top: 255px;
    left: 2px;
    z-index: 0;
}
.house__bg-phone[data-v-7397b9b7] {
    z-index: 1;
}
.house__bg-house[data-v-7397b9b7] {
    top: 117px;
    left: 208px;
    z-index: 2;
}
.house__cloud-1[data-v-7397b9b7] {
    top: 290px;
    left: 100px;
    z-index: 3;
}
.house__cloud-2[data-v-7397b9b7] {
    top: 290px;
    left: 2px;
    z-index: 4;
}
@keyframes bounce_cloud-data-v-7397b9b7 {
from {
      transform: translateY(0);
}
to {
      transform: translateY(-20px);
}
}
@keyframes opacity_star-data-v-7397b9b7 {
from {
      opacity: 100%;
}
to {
      opacity: 40%;
}
}
@keyframes bounce_cloud_reversed-data-v-7397b9b7 {
from {
      transform: translateY(0);
}
to {
      transform: translateY(20px);
}
}
@keyframes bounce_bg_cloud-data-v-7397b9b7 {
from {
      transform: translateY(0);
}
to {
      transform: translateY(10px);
}
}
@keyframes bounce_house-data-v-7397b9b7 {
from {
      transform: translateY(0);
}
to {
      transform: translateY(-8px);
}
}
.house__bounce_cloud[data-v-7397b9b7] {
    animation: bounce_cloud-data-v-7397b9b7 3.5s alternate infinite cubic-bezier(1, 0.85, 0.6, 1);
}
.house__bounce_cloud_reversed[data-v-7397b9b7] {
    animation: bounce_cloud_reversed-data-v-7397b9b7 2s alternate infinite cubic-bezier(1, 0.85, 0.6, 1);
}
.house__bounce_bg_cloud[data-v-7397b9b7] {
    animation: bounce_bg_cloud-data-v-7397b9b7 2s alternate infinite cubic-bezier(1, 0.85, 0.6, 1);
}
.house__bounce_house[data-v-7397b9b7] {
    animation: bounce_house-data-v-7397b9b7 2s alternate infinite cubic-bezier(1, 0.85, 0.6, 1);
}
.house__opacity_star[data-v-7397b9b7] {
    animation: opacity_star-data-v-7397b9b7 1.7s alternate infinite cubic-bezier(1, 0.85, 0.6, 1);
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/components/animations/House.vue"],"names":[],"mappings":";AA2BA;IAAA,kBAAA;IAAA,aAAA;IAAA,gBAAA;IAAA,iBAAA;IAAA,kBAAA;IAAA,YAAA;IAAA,uBAAA;IAAA,wBAAA;IAAA,iBAAA;IAAA,iBAAA;IAAA,+LAAA;AAAA;AAAA;AAAA;QAAA,aAAA;AAAA;AAAA;AAGA;IAAA,YAAA;AAAA;AAAA;AAAA;QAAA,aAAA;AAAA;AAAA;AASA;;;;;;IAAA,kBAAA;AAAA;AAIA;IAAA,UAAA;IAAA,WAAA;IAAA,WAAA;AAAA;AAIA;IAAA,UAAA;IAAA,SAAA;IAAA,UAAA;AAAA;AAIA;IAAA,UAAA;AAAA;AAIA;IAAA,UAAA;IAAA,WAAA;IAAA,UAAA;AAAA;AAIA;IAAA,UAAA;IAAA,WAAA;IAAA,UAAA;AAAA;AAIA;IAAA,UAAA;IAAA,SAAA;IAAA,UAAA;AAAA;AAGA;AACA;MACA,wBAAA;AACA;AACA;MACA,4BAAA;AACA;AACA;AAEA;AACA;MACA,aAAA;AACA;AACA;MACA,YAAA;AACA;AACA;AAEA;AACA;MACA,wBAAA;AACA;AACA;MACA,2BAAA;AACA;AACA;AAEA;AACA;MACA,wBAAA;AACA;AACA;MACA,2BAAA;AACA;AACA;AAEA;AACA;MACA,wBAAA;AACA;AACA;MACA,2BAAA;AACA;AACA;AAEA;IACA,6FAAA;AACA;AAEA;IACA,oGAAA;AACA;AAEA;IACA,8FAAA;AACA;AAEA;IACA,2FAAA;AACA;AAEA;IACA,6FAAA;AACA","sourcesContent":["<template>\n  <div class=\"house__wrapper\">\n    <div class=\"house\">\n      <div class=\"house__star house__opacity_star\">\n        <img alt=\"star\" src=\"img/web/banner/star.webp\" width=\"150\" />\n      </div>\n      <div class=\"house__bg-cloud house__bounce_bg_cloud\">\n        <img alt=\"bg-cloud\" src=\"img/web/banner/capa-nube-bg.webp\" width=\"700\" />\n      </div>\n      <div class=\"house__bg-phone\">\n        <img alt=\"bg-phone\" src=\"img/web/banner/movil-luz.webp\" width=\"800\" />\n      </div>\n      <div class=\"house__bg-house house__bounce_house\">\n        <img alt=\"bg-house\" src=\"img/web/banner/casa.webp\" width=\"350\" />\n      </div>\n      <div class=\"house__cloud-1 house__bounce_cloud_reversed\">\n        <img alt=\"cloud-1\" src=\"img/web/banner/capa-nube-1.webp\" width=\"700\" />\n      </div>\n      <div class=\"house__cloud-2 house__bounce_cloud\">\n        <img alt=\"cloud-2\" src=\"img/web/banner/capa-nube-2.webp\" width=\"700\" />\n      </div>\n    </div>\n  </div>\n</template>\n\n<style scoped lang=\"postcss\">\n.house {\n  @apply transform translate-y-[-13px] translate-x-[-105px] scale-[.85] lg:h-[672px] relative my-0 mx-auto w-[50rem];\n\n  &__wrapper {\n    @apply w-[34rem] lg:h-[672px];\n  }\n\n  &__bg-cloud,\n  &__bg-house,\n  &__bg-phone,\n  &__cloud-1,\n  &__cloud-2,\n  &__star {\n    @apply absolute;\n  }\n\n  &__star {\n    @apply -z-[1] top-[100px] left-[100px];\n  }\n\n  &__bg-cloud {\n    @apply z-0 top-[255px] left-[2px];\n  }\n\n  &__bg-phone {\n    @apply z-[1];\n  }\n\n  &__bg-house {\n    @apply z-[2] top-[117px] left-[208px];\n  }\n\n  &__cloud-1 {\n    @apply z-[3] top-[290px] left-[100px];\n  }\n\n  &__cloud-2 {\n    @apply z-[4] top-[290px] left-[2px];\n  }\n\n  @keyframes bounce_cloud {\n    from {\n      transform: translateY(0);\n    }\n    to {\n      transform: translateY(-20px);\n    }\n  }\n\n  @keyframes opacity_star {\n    from {\n      opacity: 100%;\n    }\n    to {\n      opacity: 40%;\n    }\n  }\n\n  @keyframes bounce_cloud_reversed {\n    from {\n      transform: translateY(0);\n    }\n    to {\n      transform: translateY(20px);\n    }\n  }\n\n  @keyframes bounce_bg_cloud {\n    from {\n      transform: translateY(0);\n    }\n    to {\n      transform: translateY(10px);\n    }\n  }\n\n  @keyframes bounce_house {\n    from {\n      transform: translateY(0);\n    }\n    to {\n      transform: translateY(-8px);\n    }\n  }\n\n  &__bounce_cloud {\n    animation: bounce_cloud 3.5s alternate infinite cubic-bezier(1, 0.85, 0.6, 1);\n  }\n\n  &__bounce_cloud_reversed {\n    animation: bounce_cloud_reversed 2s alternate infinite cubic-bezier(1, 0.85, 0.6, 1);\n  }\n\n  &__bounce_bg_cloud {\n    animation: bounce_bg_cloud 2s alternate infinite cubic-bezier(1, 0.85, 0.6, 1);\n  }\n\n  &__bounce_house {\n    animation: bounce_house 2s alternate infinite cubic-bezier(1, 0.85, 0.6, 1);\n  }\n\n  &__opacity_star {\n    animation: opacity_star 1.7s alternate infinite cubic-bezier(1, 0.85, 0.6, 1);\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
